import { CharacterTest } from './types'

/**
 * Removes all instances of a character except the first one.
 */
export const keepFirst = (str: string, character: string): string => {
  let result = ''
  let targetCharFound = false

  str.split('').forEach((char) => {
    if (char === character) {
      if (!targetCharFound) {
        result += char
        targetCharFound = true
      }
    } else {
      result += char
    }
  })

  return result
}

/**
 * Removes all instances of a character except the last one.
 */
export const keepLast = (str: string, character: string): string => {
  return reverseString(keepFirst(reverseString(str), character))
}

/**
 * Flips the order of characters in a string.
 */
export const reverseString = (str: string): string => {
  return str.split('').reverse().join('')
}

/**
 * Removes all instances of a character.
 */
export const removeAll = (str: string, charToRemove: string): string => {
  return str.split(charToRemove).join('')
}

/**
 * Removes all instances of a character except those described by the predicate.
 */
export const keepOnly = (str: string, charToKeep: CharacterTest): string => {
  return str
    .split('')
    .filter((char, i) => charToKeep(char, i, str))
    .join('')
}

/**
 * Adds a new substring to a string at a given position.
 */
export const insertAt = (
  str: string,
  strToInsert: string,
  position: number
): string => [str.slice(0, position), strToInsert, str.slice(position)].join('')

/**
 * Separates a string into two parts, breaking at the given position.
 */
export const splitAt = (value: string, position: number) => {
  return [value.slice(0, position), value.slice(position)]
}

/**
 * Removes extra decimal digits without rounding.
 */
export const truncateDecimal = (
  str: string,
  decimalSeparator: string,
  decimalDigits: number
): string => {
  const decimalPosition = str.indexOf(decimalSeparator)

  if (decimalPosition === -1) {
    return str
  }

  return splitAt(str, decimalPosition + decimalDigits + 1)[0]
}

/**
 * @returns the last index that passes the test, or -1 if nothing passes.
 */
export const getLastIndex = (str: string, characterTest: CharacterTest) => {
  for (let i = str.length; i > 0; i--) {
    if (characterTest(str[i], i, str)) {
      return i
    }
  }
  return -1
}
